/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './FireTvPad.css';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {
  IconButton, Menu, MenuItem, useMediaQuery,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSectionsRef } from '../../context/SectionsRefContext';
import menuRoute from '../../config/menuRoute';
import FireTvPadMenuStyled from './FireTvPadMenuStyled';
import TranslatedText from '../text/TranslatedText';

function FireTvPad() {
  const { sectionsRef, currentIndex } = useSectionsRef();
  const isAbove1000 = useMediaQuery('(min-width:1000px)');
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolling, setIsScrolling] = useState(false);
  const currentRouteIndex = menuRoute.findIndex((r) => r.path === location.pathname);
  const [activeIndex, setActiveIndex] = useState(currentRouteIndex >= 0 ? currentRouteIndex : 0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleCenterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectMenuItem = (path, index) => {
    setActiveIndex(index);
    handleCloseMenu();
    navigate(path);
  };

  const getScrollParent = (element) => {
    let parent = element.parentElement;
    while (parent) {
      const { overflowY } = window.getComputedStyle(parent);
      if (overflowY === 'auto' || overflowY === 'scroll') {
        return parent;
      }
      parent = parent.parentElement;
    }
    return window; // fallback
  };
  const scrollToSection = (index) => {
    const element = sectionsRef.current[index];
    if (!element) return;

    setIsScrolling(true); // ⛔ bloque les clics

    const block = isAbove1000 ? 'center' : 'start';
    const scrollParent = getScrollParent(element);

    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth', block });
      setIsScrolling(false); // ✅ débloque après 1s
    }, 300);
  };

  const handleScrollUp = () => {
    if (currentIndex <= 0) return;
    scrollToSection(currentIndex - 1);
  };

  const handleScrollDown = () => {
    const maxIndex = sectionsRef.current.length - 1;
    if (currentIndex >= maxIndex) return;
    scrollToSection(currentIndex + 1);
  };
  const handleNavigateLeft = () => {
    const newIndex = activeIndex > 0 ? activeIndex - 1 : menuRoute.length - 1;
    setActiveIndex(newIndex);
    window.scrollTo({ top: 0, behavior: 'auto' });
    navigate(menuRoute[newIndex].path);
  };

  const handleNavigateRight = () => {
    const newIndex = activeIndex < menuRoute.length - 1 ? activeIndex + 1 : 0;
    setActiveIndex(newIndex);
    const scrollTarget = document.querySelector('body');
    scrollTarget.scrollTo({ top: 0, behavior: 'auto' });

    navigate(menuRoute[newIndex].path);
  };

  useEffect(() => {
    const newRouteIndex = menuRoute.findIndex((r) => r.path === location.pathname);
    if (newRouteIndex >= 0) {
      setActiveIndex(newRouteIndex);
    }
  }, [location.pathname]);

  const CurrentIcon = menuRoute[activeIndex].Icon || HomeRoundedIcon;

  return (
    <div className="fire-tv-pad-container">
      <div className="fire-tv-pad">
        <div className="circle-container">
          <IconButton
            className="center-button"
            onClick={handleCenterClick}
            sx={{ border: '#3a3a3a 2px solid' }}
          >
            <CurrentIcon sx={{ fontSize: 25, color: 'white' }} />
          </IconButton>
          <FireTvPadMenuStyled
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{
              color: 'white',
              minWidth: 160,
            }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            {menuRoute.map((route, realIndex) => {
              if (realIndex === activeIndex) return null; // on skip l’actuel

              return (
                <MenuItem
                  key={route.path}
                  onClick={() => handleSelectMenuItem(route.path, realIndex)}
                >
                  <TranslatedText txt={route.label} />
                </MenuItem>
              );
            })}
          </FireTvPadMenuStyled>
          <button className="arrow-button up" onClick={handleScrollUp} disabled={isScrolling || currentIndex - 1 <= 0}>
            <KeyboardArrowUpIcon sx={{ fontSize: 30 }} />
          </button>
          <button className="arrow-button down" onClick={handleScrollDown} disabled={isScrolling || currentIndex >= sectionsRef.current.length - 1}>
            <KeyboardArrowDownIcon sx={{ fontSize: 30 }} />
          </button>
          <button className="arrow-button left">
            <KeyboardArrowLeftIcon sx={{ fontSize: 30 }} onClick={handleNavigateLeft} />
          </button>
          <button className="arrow-button right">
            <KeyboardArrowRightIcon sx={{ fontSize: 30 }} onClick={handleNavigateRight} />
          </button>
        </div>
      </div>
    </div>
  );
}

FireTvPad.propTypes = {
  sectionsRef: PropTypes.shape({
    current: PropTypes.arrayOf(PropTypes.instanceOf(Element)),
  }).isRequired,
};

export default FireTvPad;
